import {
  Note,
  NoteSchema
} from '@buf/studyo_studyo-today-planners.bufbuild_es/studyo/today/planners/v1/resources/note_pb';
import {
  Work,
  WorkSchema
} from '@buf/studyo_studyo-today-planners.bufbuild_es/studyo/today/planners/v1/resources/work_pb';
import {
  PublishedWork,
  PublishedWorkSchema
} from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/published_work_pb';
import { DescMessage, JsonObject, toJson } from '@bufbuild/protobuf';
import type { MessageShape } from '@bufbuild/protobuf/dist/cjs/types';

export function convertNoteToJson(note: Note): JsonObject {
  return convertModelToJson(NoteSchema, note);
}

export function convertPublishedWorkToJson(work: PublishedWork): JsonObject {
  return convertModelToJson(PublishedWorkSchema, work);
}

export function convertWorkToJson(work: Work): JsonObject {
  return convertModelToJson(WorkSchema, work);
}

function convertModelToJson<Desc extends DescMessage>(schema: Desc, message: MessageShape<Desc>): JsonObject {
  // We force the type to be JsonObject because we know that the message is an object here.
  return toJson(schema, message, { enumAsInteger: true }) as JsonObject;
}
